import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { INIT_CONFIRMATION_PAGE } from 'app/constants';
import getReservations from './getReservations';

export default function* watchInitPage() {
  yield call(takeLatest, INIT_CONFIRMATION_PAGE, getReservations);
}
